import { WebCheckInPage } from "../webCheckIn";
import { AppStandardButton } from "../../components/UI/AppButtons";
import React from "react";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { StripeTransactionDetails } from "../../@types/Booking/stripeTransactionDetails";

export function CancelledPageForStripe() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const stripePageRedirectionUrl: StripeTransactionDetails = {
    sessionId: searchParams.get("sessionId") || "",
    priceId: searchParams.get("priceId") || "",
    reservationId: searchParams.get("reservationId") || "",
    userId: searchParams.get("userId") || "",
  };
  const handleCallback = () => {
    fetch("")
      .then((response) => {})
      .catch((error) => {});
  };
  return (
    <section className="min-h-[80vh] box-border px-44  flex flex-col border-t-2 border-solid border-grey-300">
      <header className="grow flex flex-col items-center justif-center gap-4 box-border py-8">
        <img src="/assets/images/close.png" className="h-18 w-18" />
        <h1 className="text-3xl font-bold text-[#f84434] py-2 mt-4">
          {t("Sorry! Your Payment is Failed")}
        </h1>
        <p className="font-bold text-black-600"></p>
        <AppStandardButton
          href="/embed"
          className={"w-fit py-4 "}
          color="secondaryColor"
          style={{ borderRadius: "5" }}
        >
          <span className="normal-case text-[#ffffff] p-1 text-lg">
            {" "}
            Homepage
          </span>
        </AppStandardButton>
      </header>
      <main></main>
      <footer className="text-gray-600 box-border pb-32">
        <div className="box-border border-2 border-solid border-grey-200 px-8"></div>
      </footer>
    </section>
  );
}
